'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = priceString;

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_numeral2.default.register('locale', '#.###,## CUR', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: ''
  }
});

_numeral2.default.register('locale', '#,###.## CUR', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: ''
  }
});

_numeral2.default.register('locale', 'CUR #.###,##', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: ''
  }
});

_numeral2.default.register('locale', 'CUR #,###.##', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: ''
  }
});

function priceString(selectedCurrencyFormat, qty, currency) {
  if ( // selectedCurrencyFormat !== '#.###,## CUR' &&
  selectedCurrencyFormat !== '#,###.## CUR' && selectedCurrencyFormat !== 'CUR #.###,##' && selectedCurrencyFormat !== 'CUR #,###.##') {
    selectedCurrencyFormat = '#.###,## CUR';
  }

  _numeral2.default.locale(selectedCurrencyFormat);
  var qtyNum = Number(qty);
  var result = (0, _numeral2.default)(qtyNum).format('$0,0.00');

  if (selectedCurrencyFormat === '#.###,## CUR' || selectedCurrencyFormat === '#,###.## CUR') {
    return result + ' ' + currency;
  }

  return currency + ' ' + result;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/priceString.js
// module id = 90
// module chunks = 0